
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import OttPlatFormsList from './OttPlatFormsList'
import GenerlistInListMovies from './GenerlistInListMovies'
import { onlyChipTypePath } from '../Data/MovieStaticData'
import { paths } from '../Data/MovieStaticData'
function tablemodel(props) {
  const {
    editpop,
    setpop,
    path,
    ottListValues,
    localValue,
    genresValues,
    ageRestrictionChip,
    genreChip,
    dateOtt,
    onDateChangeOtt,
    date,
    onDateChange,
    ottPlatformFun,
    handleInputChange,
    handlecancelClick,
    handleSaveClick,
  } = props
  const ageRestrictionStaticData = ['U/A', 'U', 'A', 'S']
  // console.log(localValue, 'localValue2222')
  const validationTrue = {
    main: { color: 'red', fontSize: '12px' },
  }
  const validationFalse = {
    main: { color: 'black', fontSize: '12px' },
  }

  return (
    <div>
      {' '}
      <Modal show={editpop} fullscreen={'md-down'} onHide={() => setpop(false)}>
        <Modal.Header handlecancelClick>
          <Modal.Title>Edit {path}</Modal.Title>
        </Modal.Header>

        <div
          style={{
            display: 'flex',
            gap: '10px',
            marginTop: '10px',
            justifyContent: 'center',
          }}
        >
          {path === 'ageRestriction' ? (
            <div className='agerestDiv'>
              {ageRestrictionStaticData.map(item => (
                <div
                  key={item}
                  value={item}
                  className={localValue === item ? ' colorBlue  ' : 'agebox'}
                  onClick={ageRestrictionChip}
                >
                  {item}
                </div>
              ))}
            </div>
          ) : (
            ''
          )}
          {path === 'genre_En' ? (
            <GenerlistInListMovies
              genresValues={genresValues}
              path={path}
              genreChip={genreChip}
              localValue={localValue}
            />
          ) : (
            ''
          )}
          {path === 'genre_Te' ? (
            <GenerlistInListMovies path={path} genreChip={genreChip} localValue={localValue} />
          ) : (
            ''
          )}
          {path === 'ottReleasedDate' ? (
            <input type='date' value={dateOtt} onChange={onDateChangeOtt} />
          ) : (
            ''
          )}
          {path === 'allMoviesReleasedDate' || path === 'movieReleasedDateUI' ? (
            <input type='date' value={date} onChange={onDateChange} />
          ) : (
            ''
          )}
          {path === 'ottPlatform' ? (
            <OttPlatFormsList
              ottListValues={ottListValues}
              ottPlatformFun={ottPlatformFun}
              localValue={localValue}
            />
          ) : (
            ''
          )}
        </div>

        <Modal.Body>
          {!onlyChipTypePath.includes(path) && (
            <div
              style={{
                display: 'flex',
                padding: '5px',
                flexDirection: 'column',
              }}
            >
              {path === 'about_En' || path === 'about_Te' ? (
                <textarea
                  style={{
                    minWidth: '50px!important',
                    maxWidth: '99.99%!important',
                    transition: 'width 0.25s',
                    textAlign: 'center',
                  }}
                  type='text'
                  value={paths.some(item => item === path) ? props.rolename : localValue}
                  className='inputclassName'
                  onChange={handleInputChange}
                  rows={8}
                  cols={50}
                />
              ) : path === 'movieRating' || path === 'yousayRating' ? (
                <>
                  <input
                    type='text'
                    maxLength='3'
                    value={paths.some(item => item === path) ? props.rolename : localValue}
                    className='inputclassName'
                    onChange={e => handleInputChange(e, path)}
                  />

                  {path === 'movieRating' ? (
                    <div style={localValue > 100 ? validationTrue.main : validationFalse.main}>
                      movieRating max-limit is 100
                    </div>
                  ) : (
                    <div style={localValue > 5 ? validationTrue.main : validationFalse.main}>
                      yousayRating max-limit is 5
                    </div>
                  )}
                </>
              ) : (
                <textarea
                  style={{
                    minWidth: '50px!important',
                    maxWidth: '99.99%!important',
                    transition: 'width 0.25s',
                    textAlign: 'center',
                  }}
                  type='text'
                  value={paths.some(item => item === path) ? props.rolename : localValue}
                  className='inputclassName'
                  onChange={e => handleInputChange(e, path)}
                />
              )}
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <div style={{ display: 'flex' }}>
            <button className='buttonclassName btn btn-primary' onClick={handlecancelClick}>
              Cancel
            </button>
            <button className='buttonclassName1 btn btn-primary' onClick={handleSaveClick}>
              Ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default tablemodel
